// removed by extract-text-webpack-plugin
module.exports = {"buttonOutline":"styles__buttonOutline___1di8I"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/button/styles.css
// module id = fb/t
// module chunks = 2